import React from "react";
import Spinner from "../Spinner/Spinner";
type Props = {
  isFetching?: boolean;
  disabled?: boolean;
  type?: string;
  value?: string;
  buttonStyle: "light" | "secondary" | "primary";
  [key: string]: any;
};

const ButtonWithSpinner = ({
  buttonStyle,
  disabled,
  isFetching,
  value,
  ...rest
}: Props) => <div className="form-group">
    <button className={`btn btn-${buttonStyle} btn-block`} type="submit" disabled={disabled} style={isFetching ? {
    padding: '0',
    height: '50px'
  } : {}} {...rest}>
      {isFetching ? <Spinner /> : value}
    </button>
  </div>;

ButtonWithSpinner.defaultProps = {
  buttonStyle: 'light',
  // eslint-disable-line
  disabled: false,
  isFetching: false,
  type: 'submit',
  value: ''
};
export default ButtonWithSpinner;